export default "__VITE_ASSET__br7IFirP__"